import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-selection-dialog',
  templateUrl: './contact-selection-dialog.component.html',
  styleUrls: ['./contact-selection-dialog.component.scss']
})
export class ContactSelectionDialogComponent {

}
